import { STATICS } from 'statics'
import { CartMonthlyValue } from '../cart-monthly-value'
import './style.scss'

export function CartItems({ cart = [], onUpdateProductClick, onRemoveProductClick, totalValue }) {
  function renderCartItem(item) {
    const { id, name, logo, familyName, value } = item
    return (
      <li key={id} className='cart-item-container'>
        <div className='cart-item'>
          <img src={logo} alt={`Logo ${name}`} className='logo' />
          <div className='content'>
            <span className='name'>{name}</span>
            <span className='family-name'>{familyName}</span>
            <CartMonthlyValue isPrimary value={value} />
            <button
              className='update-plan'
              type='button'
              onClick={() => onUpdateProductClick(item)}
            >
              Alterar plano
            </button>
          </div>
          <div className='info'>
            <button className='delete' type='button' onClick={() => onRemoveProductClick(item)}>
              <STATICS.DELETE_OUTLINE className='icon' />
            </button>
          </div>
        </div>
      </li>
    )
  }

  function renderEmptyCart() {
    return (
      <>
        <div className='empty-cart'>
          <STATICS.CART_EMPTY className='icon' />
          <span className='title'>Carrinho Vazio</span>
          <p className='description'>
            Você ainda não adicionou nenhum item ao carrinho.{' '}
            <strong>Confira abaixo nossos produtos.</strong>
          </p>
        </div>
        <hr className='divider' />
      </>
    )
  }

  function renderCartTotalValues() {
    return (
      <div className='total-values-container'>
        <div className='info'>
          <span className='value-label'>Valor total:</span>
          <CartMonthlyValue isPrimary value={totalValue} />
        </div>
        <div className='description'>
          <STATICS.INFO_OUTLINE className='icon' />
          <span className='info'>
            Esse valor <strong>será somado à fatura do seu plano de internet</strong> todo mês, a
            partir da próxima fatura.
          </span>
        </div>
      </div>
    )
  }

  function renderCartItems() {
    return <ul className='cart-items'>{cart.map(renderCartItem)}</ul>
  }

  function renderCartContent() {
    return (
      <div className='cart-items-container'>
        {renderCartItems()}
        {renderCartTotalValues()}
      </div>
    )
  }

  return cart.length === 0 ? renderEmptyCart() : renderCartContent()
}
